/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M241.587 193.033c8.278-8.081 21.512-7.969 29.678.169l68.058 67.973c8.25 8.25 8.25 21.625 0 29.876-8.222 8.25-21.597 8.278-29.876.028L277.46 259.09v229.6c0 11.657-9.461 21.118-21.119 21.118-11.657 0-21.118-9.46-21.118-21.118v-230.5l-33.93 33.057a21.1 21.1 0 01-14.755 5.997c-5.49 0-10.982-2.14-15.12-6.391-8.138-8.363-7.97-21.71.393-29.848zm113.45 161.61c8.25-8.25 21.626-8.25 29.876 0l50.938 50.937c8.25 8.25 8.25 21.625 0 29.876a21.152 21.152 0 01-14.952 6.166 21.088 21.088 0 01-14.924-6.166l-50.937-50.938c-8.25-8.25-8.25-21.625 0-29.876zm-227.284 0c8.25-8.25 21.625-8.25 29.875 0s8.25 21.625 0 29.875l-50.965 50.938a21.136 21.136 0 01-14.924 6.166 21.104 21.104 0 01-14.952-6.166c-8.25-8.25-8.25-21.626 0-29.876zm361.35-119.838c11.657 0 21.118 9.461 21.118 21.119 0 11.657-9.46 21.118-21.118 21.118h-72.056c-11.657 0-21.118-9.461-21.118-21.118 0-11.658 9.46-21.119 21.118-21.119zm-393.495 0c11.657 0 21.118 9.461 21.118 21.119 0 11.657-9.46 21.118-21.118 21.118H23.552c-11.658 0-21.119-9.461-21.119-21.118 0-11.658 9.461-21.119 21.119-21.119zm310.359-158.39c8.25-8.251 21.625-8.251 29.875 0 8.25 8.25 8.25 21.596 0 29.847l-50.937 50.937c-4.111 4.14-9.518 6.195-14.924 6.195-5.406 0-10.813-2.056-14.924-6.195-8.25-8.25-8.25-21.597 0-29.847zm-329.18-.012c8.25-8.25 21.625-8.25 29.875 0l50.966 50.938c8.25 8.25 8.25 21.625 0 29.875a21.104 21.104 0 01-14.952 6.167 21.088 21.088 0 01-14.923-6.167L76.787 106.28c-8.25-8.25-8.25-21.626 0-29.876zm179.546-74.38c11.657 0 21.118 9.462 21.118 21.12v72.055c0 11.658-9.46 21.119-21.118 21.119-11.657 0-21.118-9.461-21.118-21.119V23.142c0-11.657 9.46-21.118 21.118-21.118z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconSponsored = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconSponsored.defaultProps = {
  theme,
};
IconSponsored.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconSponsored.displayName = 'IconSponsored';
export { IconSponsored };
